import { useChildMatches, useLocation, useMatch, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

export function useGetMatchedRoute() {
  const rootMatch = useMatch({ strict: false });
  const childMatches = useChildMatches();
  return childMatches.at(-1) ?? rootMatch;
}

export function useSetRouteState<T extends Record<string, unknown>>() {
  const { params, search } = useGetMatchedRoute();
  const { hash } = useLocation();
  const navigate = useNavigate();

  function updateRouteState(newState: T) {
    navigate({
      search: search as true,
      params: params as true,
      hash: hash,
      state: newState,
      replace: true,
    });
  }
  return updateRouteState;
}

export function useSyncRouteState<T extends Record<string, unknown>>(state: T, enabled = true) {
  const updateRouteState = useSetRouteState<T>();
  useEffect(() => {
    if (enabled) {
      updateRouteState(state);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state, enabled]);
}
